import React, { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import SwiperGallery from "./SwiperGallery";
import ListingDetail from "./ListingDetail";

const ensureLink = (href, id) => {
  if (!document.querySelector(`link[data-id="${id}"]`)) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.dataset.id = id;
    document.head.appendChild(link);
  }
};

const ensureScript = (src, id) =>
  new Promise((resolve) => {
    const existing = document.querySelector(`script[data-id="${id}"]`);
    if (existing) {
      if (existing.dataset.loaded) {
        resolve();
      } else {
        existing.addEventListener("load", () => resolve());
      }
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.dataset.id = id;
    script.defer = true;
    script.onload = () => {
      script.dataset.loaded = "true";
      resolve();
    };
    document.body.appendChild(script);
  });

// Bootstrap Icons לצורך האייקונים בקרוסלה/דף הדירה גם בוורדפרס
ensureLink(
  "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css",
  "bootstrap-icons",
);
ensureLink(
  "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css",
  "bootstrap-css-shared",
);
ensureScript(
  "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js",
  "bootstrap-js-shared",
);
ensureLink(
  "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css",
  "swiper-css-shared",
);
ensureScript(
  "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js",
  "swiper-js-shared",
);

// === טוען את קומפוננטת החיפוש (אם קיים DIV ב-WordPress) ===
const guesty_listings_carousel = document.getElementById(
  "guesty_listings_carousel",
);
if (guesty_listings_carousel) {
  ReactDOM.createRoot(guesty_listings_carousel).render(<SwiperGallery />);
}

// === עמוד דירה (WordPress shortcode) ===
const guesty_listing_detail = document.getElementById("guesty_listing_detail");

const mapListing = (item) => ({
  id: item._id,
  title: item.title,
  city: `${item.address?.city || ""}${
    item.address?.country ? `, ${item.address.country}` : ""
  }`.trim(),
  roomType: item.roomType || "",
  propertyType: item.propertyType || "",
  image: item.pictures?.[0]?.original || "",
  pictures: (item.pictures || [])
    .map((p) => (typeof p === "string" ? p : p.original))
    .filter(Boolean),
  summary: item.publicDescription?.summary || "",
  description: "",
  access: "",
  guests: item.accommodates || 0,
  bedrooms: item.bedrooms ?? 0,
  beds: item.beds ?? item.bedsCount ?? item.bedCount ?? item.bedrooms ?? 0,
  bathrooms: item.bathrooms ?? 0,
  price: item.prices?.basePrice ? `₪${item.prices.basePrice}` : "₪—",
  reviews: {
    avg: item.reviews?.avg || 4.8,
    total: item.reviews?.total || 62,
  },
  amenities: item.amenities || [],
  coords: {
    lat: item.address?.lat,
    lng: item.address?.lng,
  },
  neighborhood: item.address?.neighborhood || "",
  checkin: "",
  checkout: "",
  directions: "",
});

if (guesty_listing_detail) {
  const DetailPage = () => {
    const initialListing = useMemo(() => {
      try {
        const raw = guesty_listing_detail.dataset.listing;
        if (raw) return JSON.parse(raw);
      } catch (e) {
        console.warn("Failed to parse listing from data attribute", e);
      }
      return window.__LISTING_DETAIL__ || null;
    }, []);

    const [listing, setListing] = useState(initialListing);
    const [error, setError] = useState("");

    useEffect(() => {
      if (listing) return;
      const params = new URLSearchParams(window.location.search);
      const listingId = params.get("listingId");
      if (!listingId) {
        setError("לא נמצא listingId ב-URL או בנתונים");
        return;
      }
      fetch("https://seasideeilat.co.il/wp-json/guesty/v1/listings")
        .then((res) => res.json())
        .then((data) => {
          const match = data?.listings?.find((l) => l._id === listingId);
          console.log(match);
          console.log(listingId);
          console.log(data);

          if (match) {
            setListing(mapListing(match));
          } else {
            setError("לא נמצאה דירה תואמת");
          }
        })
        .catch(() => setError("שגיאה בטעינת הדירה"));
    }, [listing]);

    if (error)
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "120px",
            color: "red",
          }}
        >
          {error}
        </div>
      );
    if (!listing)
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
          }}
        >
          <div className="lds-dual-ring"></div>
        </div>
      );

    // אם הדאטה מגיעה מבחוץ כבר ממופה, השתמש בה; אחרת, מיפה לשדות שמצופים
    const mapped = listing._id ? mapListing(listing) : listing;
    return <ListingDetail listing={mapped} />;
  };

  ReactDOM.createRoot(guesty_listing_detail).render(<DetailPage />);
}

const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
